import(/* webpackMode: "eager", webpackExports: ["ExamResourceLayout"] */ "/vercel/path1/components/exam-resource-layout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ExtendedFAQSection"] */ "/vercel/path1/components/extended-faq-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path1/node_modules/next/dist/client/app-dir/link.js");
